import React from 'react';
import { Typography, Table } from 'antd';
import { CommonTable, SkeletonHOC } from 'common';
import {
  AvailableLocationData,
  AvailableMunicipalities,
} from '../models/availableLocationData';

const { Text } = Typography;
const { Column } = Table;

const TaxTraxMunicipalitiesTable: React.FC<{
  municipalities: AvailableMunicipalities;
}> = (props: { municipalities: AvailableMunicipalities }) => {
  const { municipalities } = props;

  // create an array of all unique available tax types for dynamically generating table columns
  const availableTaxTypes = municipalities.reduce(
    (
      taxTypesArray: string[],
      currentAvailableLocationData: AvailableLocationData,
    ) => {
      Object.keys(currentAvailableLocationData.taxYearRanges)?.map(
        (taxTypeKey) => {
          if (!taxTypesArray.some((x) => x === taxTypeKey)) {
            taxTypesArray.push(taxTypeKey);
          }
        },
      );
      return taxTypesArray;
    },
    [],
  );

  const isTown = (location: AvailableLocationData) => {
    return location.hobDescription === 'TOWN';
  };

  const isVillage = (location: AvailableLocationData) => {
    return location.hobDescription === 'VILLAGE';
  };

  const showTownBillAsterisk = (location: AvailableLocationData) => {
    return isTown(location) && location.hasBill;
  };

  const showVillageBillAsterisk = (location: AvailableLocationData) => {
    return isVillage(location) && location.hasBill;
  };

  return (
    <>
      <CommonTable
        items={municipalities}
        rowKey="hobCode"
        disablePagination={true}
        fixedHeightInsideModal={true}
      >
        <Column
          width="4rem"
          title="STATE"
          dataIndex="state"
          render={(record: string) => <Text>{record}</Text>}
        />
        <Column
          width="7rem"
          title="COUNTY"
          dataIndex="county"
          render={(record: string) => <Text>{record}</Text>}
        />
        <Column
          width="12rem"
          title="TOWN"
          dataIndex="town"
          render={(record: string, location: AvailableLocationData) => (
            <Text strong={isTown(location)}>
              {record}
              {showTownBillAsterisk(location) ? '*' : ''}
            </Text>
          )}
        />
        <Column
          width="12rem"
          title="VILLAGE"
          dataIndex="village"
          render={(record: string, location: AvailableLocationData) => (
            <Text strong={isVillage(location)}>
              {record}
              {showVillageBillAsterisk(location) ? '*' : ''}
            </Text>
          )}
        />
        {availableTaxTypes.map((taxType) => {
          return (
            <Column
              width="auto"
              title={taxType.toUpperCase()}
              dataIndex={`taxYearRanges.${taxType}`}
              key={taxType}
              render={(record: string) => {
                return record && <Text>{record}</Text>;
              }}
            />
          );
        })}
      </CommonTable>
      <Text>* Bill Preview & Bill Download also available</Text>
    </>
  );
};

export default SkeletonHOC({
  initProp: 'municipalities',
  rows: 12,
  fullWidth: true,
})(TaxTraxMunicipalitiesTable);
